import SpriteSymbol from "../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/_svg-sprite-loader@6.0.9@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "agent",
  "use": "agent-usage",
  "viewBox": "0 0 15.5 15.75",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 15.5 15.75\" id=\"agent\"><path d=\"M15.5 12.5V0H0v12.5h5.25v1.25h-2.5v2h10v-2h-2.5V12.5zm-14-11H14V11H1.5z\" /><path d=\"M2 4.81h1.5V3.5h1.34V2H2v2.81zM12 9h-1.19v1.5h2.69V7.69H12V9zM10.81 3.5H12v1.31h1.5V2h-2.69v1.5zM3.5 7.69H2v2.81h2.84V9H3.5V7.69z\" /><circle cx=\"7.75\" cy=\"6.25\" r=\"1.44\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id